import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Jednostavna provjera lozinke (može se zamijeniti s backend autentifikacijom)
  const ADMIN_PASSWORD = "admin123"; // Promijenite ovo u produkciji!

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem("travelina_admin_auth", "true");
      navigate("/admin");
    } else {
      setError("Netočna lozinka");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#020617",
        color: "#e5e7eb",
      }}
    >
      <div
        style={{
          background: "rgba(15, 23, 42, 0.96)",
          padding: "2rem",
          borderRadius: "1.5rem",
          border: "1px solid rgba(148, 163, 184, 0.35)",
          maxWidth: "400px",
          width: "100%",
        }}
      >
        <h1 style={{ marginBottom: "1.5rem", textAlign: "center" }}>
          Admin Login
        </h1>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "1rem" }}>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontSize: "0.9rem",
                color: "#9ca3af",
              }}
            >
              Lozinka
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              style={{
                width: "100%",
                padding: "0.75rem",
                background: "rgba(2, 6, 23, 0.8)",
                border: "1px solid rgba(148, 163, 184, 0.35)",
                borderRadius: "0.5rem",
                color: "#e5e7eb",
                fontSize: "1rem",
              }}
              required
            />
          </div>
          {error && (
            <p
              style={{
                color: "#ef4444",
                fontSize: "0.85rem",
                marginBottom: "1rem",
              }}
            >
              {error}
            </p>
          )}
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "0.75rem",
              background: "#f97316",
              color: "#111827",
              border: "none",
              borderRadius: "0.5rem",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Prijava
          </button>
        </form>
      </div>
    </div>
  );
}

